import DuelIcon from '@/app/components/Icons/DuelIcon';
import { useSession } from '@/hooks/useSession';
import {
  Card,
  CardBody,
  CardBodyContent,
  CardBodyHeader,
  CardBodyHeaderContent,
  CardContent,
  CardDuel,
  CardDuelAvatar,
  CardDuelName,
  CardDuelNumber,
  CardDuelProfile,
  CardDuelScore,
  CardDuelStar,
  CardDuelVs,
  CardFooter,
  CardIcon,
  CardIconImg,
  CardText,
  CardTitle
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AvatarWrapper } from '@/components/ui/avatar';
import moment from 'moment';

export function DuelsCard({ duel, handleStart, showResults, status }) {
  const { session } = useSession();
  const userAvatar = session.user.image.url;
  const opponentAvatar = duel?.opponent?.image?.url;

  function calculateTimeRemaining(expiration) {
    const now = new Date();
    const expirationTime = new Date(expiration);

    const differenceInMs = expirationTime - now;

    const days = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((differenceInMs / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((differenceInMs / (1000 * 60)) % 60);

    switch (true) {
      case days === 1:
        return '1 dia';
      case days > 1:
        return `${days} dias`;
      case hours === 1:
        return '1 hora';
      case hours > 1:
        return `${hours} horas`;
      case minutes === 1:
        return '1 minuto';
      case minutes > 1:
        return `${minutes} minutos`;
      default:
        return 'Tempo expirado';
    }
  }

  return (
    <Card hover>
      <CardContent>
        <CardIcon>
          <CardIconImg>
            <DuelIcon />
          </CardIconImg>
        </CardIcon>

        <CardBody>
          <CardBodyHeader>
            <CardBodyHeaderContent>
              <CardTitle title={duel?.['parent-taxonomy']?.name}>{duel?.['parent-taxonomy']?.name}</CardTitle>
            </CardBodyHeaderContent>

            <Badge
              variant={status === 'completed' ? 'success' : 'bright'}
              size="xs"
            >
              {duel?.['rounds-completed-by-me'] === duel?.['duel-rounds-count'] && status !== 'completed'
                ? 'Vez do oponente'
                : status === 'completed'
                  ? 'Finalizado'
                  : `Você jogou ${duel?.['rounds-completed-by-me']}/${duel?.['duel-rounds-count']} rodadas`}
            </Badge>
          </CardBodyHeader>

          <CardBodyContent>
            <CardDuel>
              <CardDuelProfile>
                <CardDuelAvatar>
                  <AvatarWrapper
                    src={duel?.['creator-id'] === session.user.id ? userAvatar : opponentAvatar}
                    text={duel?.['creator-id'] === session.user.id ? session.user.name : duel?.opponent?.name}
                  />
                  <CardDuelStar />
                </CardDuelAvatar>
                <CardDuelName title={duel?.['creator-id'] === session.user.id ? session.user.name : duel?.opponent?.name}>{duel?.['creator-id'] === session.user.id ? session.user.name : duel?.opponent?.name}</CardDuelName>
              </CardDuelProfile>

              <CardDuelScore>
                <CardDuelNumber>{duel?.['creator-id'] === session.user.id ? duel?.['rounds-won-by-me'] : duel?.opponent?.['rounds-won']}</CardDuelNumber>
                <CardDuelVs />
                <CardDuelNumber>{duel?.['invited-id'] === session.user.id ? duel?.['rounds-won-by-me'] : duel?.opponent?.['rounds-won']}</CardDuelNumber>
              </CardDuelScore>

              <CardDuelProfile>
                <CardDuelAvatar>
                  <AvatarWrapper
                    src={duel?.['invited-id'] === session.user.id ? userAvatar : opponentAvatar}
                    text={duel?.['invited-id'] === session.user.id ? session.user.name : duel?.opponent?.name}
                  />
                </CardDuelAvatar>
                <CardDuelName title={duel?.['invited-id'] === session.user.id ? session.user.name : duel?.opponent?.name}>{duel?.['invited-id'] === session.user.id ? session.user.name : duel?.opponent?.name}</CardDuelName>
              </CardDuelProfile>
            </CardDuel>
            <CardText variant={calculateTimeRemaining(duel?.['expiration-date']).includes('minuto') ? 'danger' : 'default'}>
              {moment(new Date()).isAfter(moment(duel?.['expiration-date'])) ? 'Duelo expirado' : `Expira em ${calculateTimeRemaining(duel?.['expiration-date'])}`}
            </CardText>
          </CardBodyContent>
        </CardBody>
      </CardContent>

      <CardFooter>
        {moment(new Date()).isAfter(moment(duel?.['expiration-date'])) || duel?.['rounds-completed-by-me'] === duel?.['duel-rounds-count'] ? (
          <Button
            variant="outline"
            fullWidth
            onClick={() => showResults(duel)}
          >
            Ver resultados
          </Button>
        ) : (
          <Button
            variant="outline"
            fullWidth
            onClick={() => handleStart(duel)}
          >
            Jogar
          </Button>
        )}
      </CardFooter>
    </Card>
  );
}
